import { menu as consultoriasMenu } from './consultorias/menu';

const utilidadesMenu = {
    label: 'Utilidades',
    icon: 'pi pi-fw pi-briefcase',
    rules: [...consultoriasMenu.rules],
    items: [consultoriasMenu],
};

export default utilidadesMenu